<template>
  <Layout>
  <div id="home">
    <b-modal v-model="isModalActive">
      <div class="modal-content">
        <!-- <div id="modal_close_button" @click="isModalActive = false">
          <svg style="width:50px;height:50px" viewBox="0 0 24 24">
              <path fill="#FFFFFF" d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" />
          </svg>
        </div> -->
        <div id="modal_page1" v-show="modalPage == 1">
          <div class="modal_p1">Dapat Desain Iklan Toko GRATIS?</div>
          <div class="modal_p2">Kapan lagi?</div>
          <div class="modal_p3">Cukup isi data tokomu, kami yang buatkan iklan tokomu!</div>
          <div id="modal_page1_child">
            <div class="modal_page1_child_img" style="border-style: solid; transform: scale(1.2); opacity: 1;">
              <img class="modal_page1_child_img_child" src="../../../assets/home_modal_poster1.png" @click="highlightByClass('modal_page1_child_img', 0)"/>
            </div>
            <div class="modal_page1_child_img">
              <img class="modal_page1_child_img_child" src="../../../assets/home_modal_poster2.png" @click="highlightByClass('modal_page1_child_img', 1)"/>
            </div>
            <div class="modal_page1_child_img">
              <img class="modal_page1_child_img_child" src="../../../assets/home_modal_poster3.png" @click="highlightByClass('modal_page1_child_img', 2)"/>
            </div>
          </div>
          <div class="modal_p3">Mohon cantumkan di Catatan: Judul iklan (maximum 6 kata), dan data kontak</div>
          <div class="modal_button_layout modal_button_layout_width">
            <span class="modal_button" @click="goToModalPage(2)">Selanjutnya</span>
          </div>
        </div>
        <div id="modal_page2" v-show="modalPage == 2">
          <div class="modal_p1">1 Langkah Lagi!</div>
          <div id="modal_page2_child">
            <div class="modal_page2_field">
              <span class="modal_page2_field_label">NAMA PEMILIK</span>
              <input type="text" v-model="dataModal._name" class="modal_page2_field_input"/>
            </div>
            <div class="modal_page2_field">
              <span class="modal_page2_field_label">NAMA TOKO</span>
              <input type="text" v-model="dataModal._nama_toko" class="modal_page2_field_input"/>
            </div>
            <div class="modal_page2_child_row">
              <div class="modal_page2_field">
                <span class="modal_page2_field_label">EMAIL</span>
                <input type="text" v-model="dataModal.email" class="modal_page2_field_input modal_page2_field_input_width1"/>
              </div>
              <div class="modal_page2_field">
                <span class="modal_page2_field_label modal_page2_field_label_width1">NO. HP</span>
                <input type="number" v-model="dataModal.telephone" class="modal_page2_field_input modal_page2_field_input_width2"/>
              </div>
            </div>
            <div class="modal_page2_field">
              <span class="modal_page2_field_label">JENIS USAHA</span>
              <select class="modal_page2_field_input" v-model="dataModal.jenis_usaha">
                <option value="Kuliner">Kuliner</option>
                <option value="Ritel dan grosir">Ritel dan grosir</option>
                <option value="Fashion">Fashion</option>
                <option value="Kerajinan">Kerajinan</option>
                <option value="Batik">Batik</option>
                <option value="Peralatan rumah tangga">Peralatan rumah tangga</option>
                <option value="Agribisnis">Agribisnis</option>
                <option value="Lainnya">Lainnya</option>
              </select>
            </div>
            <div class="modal_page2_field">
              <span class="modal_page2_field_label">CATATAN</span>
              <textarea rows="3" placeholder="Cantumkan judul (maksimal 6 kata) & kontak yang akan dicantumkan pada iklan.
  Contoh Catatan Lainnya :
  - Warna Dominan Hijau Tua (#HEX CODE)" v-model="dataModal.message" class="modal_page2_field_input"></textarea>
            </div>
            <!-- <div class="modal_page2_field2">
              <input type="checkbox" v-model="dataModal.terima_promosi" id="promo" name="promo" class="modal_page2_field_checkbox"/>
              <label for="promo">Saya Bersedia Mendapatkan Email Promosi dari Dirigo</label>
            </div> -->
          </div>
          <div class="modal_button_layout">
            <span class="modal_button_transparent" @click="goToModalPage(1)">Kembali</span>
            <span class="modal_button" @click="onClickSendModal">Dapatkan Gratis</span>
          </div>
        </div>
        <div id="modal_page3" v-show="modalPage == 3">
          <div class="modal_p1">{{modalPage3Titleline1}}<br>{{modalPage3Titleline2}}</div><br>
          <div class="modal_p2">{{modalPage3Title2}}</div>
          <div class="modal_p3">{{modalPage3Title3}}</div><br><br>
          <div class="modal_p3">Punya Pertanyaan? Hubungi Kami :</div>
          <span class="modal_page3_child">
            <div id="modal_page3_child_wa" @click="goToTargetViewBlank('https://wa.me/6281358224169?text=Hi Dirigo Team, saya ada pertanyaan.')">
              <svg class="modal_page3_child_wa_ic1" viewBox="498.199 -0.001 43.998 44.091">
                <path id="modal_page3_child_wa_ic1" d="M 498.1993713378906 21.99800491333008 C 498.1372985839844 9.928220748901367 507.9420776367188 0.06140628457069397 520.0428466796875 -0.0006491573876701295 C 532.298828125 -0.06270459294319153 542.1966552734375 9.77308177947998 542.1966552734375 21.99800491333008 C 542.1966552734375 34.00572967529297 532.298828125 44.02768325805664 520.3221435546875 44.08974456787109 C 508.1902770996094 44.15179443359375 498.2303771972656 34.19189834594727 498.1993713378906 21.99800491333008 Z M 508.6246643066406 33.57134246826172 C 510.0519714355469 33.10592269897461 511.2620544433594 32.82667541503906 512.3790283203125 32.36126327514648 C 514.1165771484375 31.64762115478516 515.66796875 31.67865371704102 517.4986572265625 32.33023071289063 C 522.7733154296875 34.19189834594727 528.513427734375 31.92687034606934 531.4611206054688 27.14860343933105 C 534.2225341796875 22.64958572387695 533.6019287109375 16.6612377166748 529.9718017578125 12.78277206420898 C 526.1864013671875 8.749168395996094 520.0739135742188 7.787309646606445 515.1715087890625 10.45569324493408 C 510.4242858886719 13.06202030181885 507.6627807617188 18.7400951385498 509.5245056152344 23.89069557189941 C 510.6414489746094 26.96244049072266 510.0830078125 29.44465446472168 509.0280151367188 32.11304092407227 C 508.9349670410156 32.51640319824219 508.8418884277344 32.91976165771484 508.6246643066406 33.57134246826172 Z">
                </path>
              </svg>
              <svg class="modal_page3_child_wa_ic2" viewBox="539.171 34.887 20.316 20.2">
                <path id="modal_page3_child_wa_ic2" d="M 540.017822265625 54.56227493286133 C 540.1419677734375 54.09685897827148 540.1419677734375 53.87966537475586 540.2349853515625 53.69350051879883 C 541.0728149414063 52.01800155639648 540.8865966796875 50.52867126464844 540.0798950195313 48.76008987426758 C 538.4044189453125 45.03675842285156 539.0869750976563 41.40651702880859 541.7864379882813 38.36580276489258 C 544.5789184570313 35.23200607299805 548.1781005859375 34.17705917358398 552.1807250976563 35.35611343383789 C 556.0592041015625 36.5041389465332 558.5413818359375 39.11046981811523 559.2860717773438 43.17509841918945 C 560.03076171875 47.20870590209961 558.696533203125 50.55969619750977 555.4385986328125 53.01088714599609 C 552.1807250976563 55.46207427978516 548.612548828125 55.64824295043945 544.88916015625 54.06583404541016 C 544.175537109375 53.75555038452148 543.2447509765625 53.81760787963867 542.43798828125 53.87966537475586 C 541.724365234375 53.94171905517578 541.0107421875 54.28302383422852 540.017822265625 54.56227493286133 Z M 546.4405517578125 44.35414886474609 C 547.7127075195313 42.46146011352539 547.7127075195313 42.46146011352539 546.7818603515625 40.47568893432617 C 546.223388671875 39.29663467407227 545.23046875 39.14149475097656 544.3616943359375 40.10335159301758 C 543.430908203125 41.15830230712891 543.1826171875 42.43043518066406 543.80322265625 43.70257568359375 C 545.5097045898438 47.23973083496094 548.1160888671875 49.78400421142578 552.0875854492188 50.49764251708984 C 552.9874267578125 50.65277862548828 554.1664428710938 50.09428024291992 554.9732055664063 49.53578567504883 C 555.3455810546875 49.28756332397461 555.314453125 47.67412185668945 555.1593017578125 47.64309692382813 C 554.1664428710938 47.30178833007813 553.20458984375 45.62628936767578 552.0875854492188 46.9294548034668 C 551.0947265625 48.07748031616211 550.2569580078125 47.92234039306641 549.357177734375 47.14664840698242 C 548.30224609375 46.27786636352539 547.371337890625 45.28498458862305 546.4405517578125 44.35414886474609 Z">
                </path>
              </svg>
            </div>
            <span><a href="https://wa.me/6281358224169?text=Hi Dirigo Team, saya ada pertanyaan." target="_blank">0813-5822-4169</a> / <a href="https://wa.me/6287883901240?text=Hi Dirigo Team, saya ada pertanyaan." target="_blank">0878-8390-1240</a></span>
          </span>
          <span class="modal_page3_child">
            <div id="modal_page3_child_ig" @click="goToTargetViewBlank('https://www.instagram.com/dirigo.id/')">
              <svg class="modal_page3_child_ig_ic1" viewBox="165.998 0.9 44.03 43.998">
                <path id="modal_page3_child_ig_ic1" d="M 188.0279998779297 44.89730834960938 C 175.9892425537109 44.99039459228516 166.1224212646484 35.21665954589844 165.9983062744141 23.08481788635254 C 165.9052276611328 11.94586753845215 174.3447570800781 0.9310277104377747 187.9969635009766 0.9000000357627869 C 201.3699035644531 0.9000000357627869 209.9025421142578 11.5114803314209 210.0266418457031 22.74351501464844 C 210.1507415771484 34.93741226196289 200.3460083007813 44.80422592163086 188.0279998779297 44.89730834960938 Z M 199.7254486083984 23.02276420593262 C 199.7254486083984 20.85082244873047 199.7254486083984 18.67888259887695 199.7254486083984 16.50694274902344 C 199.6944274902344 13.34211540222168 197.832763671875 11.26325702667236 194.7299652099609 11.20120239257813 C 190.2930145263672 11.10811901092529 185.8560638427734 11.10811901092529 181.4190826416016 11.20120239257813 C 178.2853088378906 11.26325798034668 176.3305511474609 13.31108665466309 176.2995147705078 16.44488906860352 C 176.2374572753906 20.81979560852051 176.2374572753906 25.22573471069336 176.2995147705078 29.60064315795898 C 176.3305511474609 32.51725006103516 178.3473358154297 34.62713241577148 181.2329254150391 34.68918991088867 C 185.73193359375 34.78227615356445 190.23095703125 34.78227615356445 194.6989440917969 34.68918991088867 C 197.7706909179688 34.62713241577148 199.6944274902344 32.45519256591797 199.7254486083984 29.3524227142334 C 199.7564697265625 27.2425365447998 199.7254486083984 25.13264846801758 199.7254486083984 23.02276420593262 Z">
                </path>
              </svg>
              <svg class="modal_page3_child_ig_ic2" viewBox="223.899 58.799 8.13 8.13">
                <path id="modal_page3_child_ig_ic2" d="M 227.9947814941406 66.92835998535156 C 225.7917938232422 66.95939636230469 223.9301300048828 65.12876129150391 223.8991241455078 62.9257926940918 C 223.8680877685547 60.69179916381836 225.6366729736328 58.83013534545898 227.8706665039063 58.79910278320313 C 230.2287750244141 58.7680778503418 232.0283813476563 60.53665924072266 232.0283813476563 62.86373901367188 C 231.9973449707031 65.09773254394531 230.1977386474609 66.92835998535156 227.9947814941406 66.92835998535156 Z">
                </path>
              </svg>
              <svg class="modal_page3_child_ig_ic3" viewBox="205.856 40.45 19.274 19.524">
                <path id="modal_page3_child_ig_ic3" d="M 225.1065368652344 43.53726196289063 C 225.1065368652344 41.67559432983398 223.9895324707031 40.49654006958008 222.1278686523438 40.49654006958008 C 217.6909027099609 40.43448638916016 213.2539520263672 40.43448638916016 208.8169860839844 40.49654006958008 C 206.9863433837891 40.52757263183594 205.9003753662109 41.73765182495117 205.8693542480469 43.56828689575195 C 205.8383178710938 45.80228424072266 205.8693542480469 48.0052490234375 205.8693542480469 50.2392463684082 C 205.8693542480469 52.41118240356445 205.8693542480469 54.5831298828125 205.8693542480469 56.75506973266602 C 205.8693542480469 58.83392715454102 206.8932647705078 59.91989135742188 209.0031433105469 59.95092391967773 C 213.3470306396484 59.98194885253906 217.6909027099609 59.98194885253906 222.0037536621094 59.95092391967773 C 223.9895324707031 59.95092391967773 225.1065368652344 58.86495208740234 225.1065368652344 56.87917709350586 C 225.1375732421875 52.41118240356445 225.1375732421875 47.97422409057617 225.1065368652344 43.53726196289063 Z M 215.4879455566406 56.3206787109375 C 212.1059112548828 56.3206787109375 209.406494140625 53.55921173095703 209.406494140625 50.17718887329102 C 209.4375457763672 46.85722732543945 212.1059112548828 44.12678527832031 215.3948669433594 44.09576034545898 C 218.8699645996094 44.06473541259766 221.6624603271484 46.82619857788086 221.6624603271484 50.2392463684082 C 221.6314392089844 53.55921173095703 218.8389434814453 56.3206787109375 215.4879455566406 56.3206787109375 Z M 222.2830047607422 44.9024772644043 C 221.6004028320313 44.9024772644043 221.0419006347656 44.34397888183594 221.0419006347656 43.66136932373047 C 221.0419006347656 42.978759765625 221.6004028320313 42.42025756835938 222.2830047607422 42.42025756835938 C 222.9656219482422 42.42025756835938 223.5241241455078 42.978759765625 223.5241241455078 43.66136932373047 C 223.5241241455078 44.34397888183594 222.9656219482422 44.9024772644043 222.2830047607422 44.9024772644043 Z">
                </path>
              </svg>
            </div>
            <span><a href="https://www.instagram.com/dirigo.id/" target="_blank">dirigo.id</a></span>
          </span>
          <span class="modal_page3_child">
            <div id="modal_page3_child_mail" @click="goToTargetViewBlank('mailto:dirigo@kst.co.id')">
              <svg class="modal_page3_child_mail_ic1" viewBox="9.024 17.352 15.225 4.811">
                <path id="modal_page3_child_mail_ic1" d="M 17.91200065612793 19.02099990844727 C 17.10199928283691 19.79299926757812 16.04700088500977 19.7819995880127 15.25599956512451 18.99200057983398 C 14.7189998626709 18.45599937438965 14.24899959564209 17.85300064086914 13.8120002746582 17.35199928283691 C 12.09500026702881 19.07699966430664 10.54399967193604 20.63500022888184 9.02400016784668 22.16300010681152 L 24.24900054931641 22.16300010681152 C 22.63999938964844 20.55400085449219 21.10199928283691 19.01300048828125 19.44899940490723 17.35899925231934 C 18.94799995422363 17.9060001373291 18.46199989318848 18.49699974060059 17.91200065612793 19.02099990844727 Z">
                </path>
              </svg>
              <svg class="modal_page3_child_mail_ic2" viewBox="8.86 10.965 15.385 7.478">
                <path id="modal_page3_child_mail_ic2" d="M 15.78800010681152 17.97800064086914 C 16.42399978637695 18.61100006103516 16.76399993896484 18.60000038146973 17.43600082397461 17.93199920654297 C 19.60499954223633 15.77200031280518 21.76600074768066 13.60400009155273 23.92600059509277 11.43400001525879 C 24.04800033569336 11.31099987030029 24.125 11.14400005340576 24.2450008392334 10.96500015258789 L 8.859999656677246 10.96500015258789 C 9.013999938964844 11.15799999237061 9.086999893188477 11.26799964904785 9.178000450134277 11.35999965667725 C 11.37899971008301 13.56799983978271 13.57900047302246 15.77799987792969 15.78800010681152 17.97800064086914 Z">
                </path>
              </svg>
              <svg class="modal_page3_child_mail_ic3" viewBox="8.058 12.096 4.481 9.059">
                <path id="modal_page3_child_mail_ic3" d="M 8.057999610900879 12.0959997177124 L 8.057999610900879 21.15500068664551 C 9.607999801635742 19.58399963378906 11.1269998550415 18.04299926757812 12.53899955749512 16.61100006103516 C 11.0930004119873 15.1540002822876 9.571000099182129 13.61999988555908 8.057999610900879 12.0959997177124 Z">
                </path>
              </svg>
              <svg class="modal_page3_child_mail_ic4" viewBox="20.614 12.054 4.531 9.135">
                <path id="modal_page3_child_mail_ic4" d="M 25.14500045776367 21.18899917602539 L 25.14500045776367 12.05399990081787 C 23.60700035095215 13.60900020599365 22.07699966430664 15.1560001373291 20.61400032043457 16.63400077819824 C 22.05200004577637 18.07999992370605 23.56399917602539 19.59900093078613 25.14500045776367 21.18899917602539 Z">
                </path>
              </svg>
              <svg class="modal_page3_child_mail_ic5" viewBox="0 0 33.15 33.15">
                <path id="modal_page3_child_mail_ic5" d="M 16.57500076293945 0 C 7.421000003814697 0 0 7.421000003814697 0 16.57500076293945 C 0 25.72900009155273 7.421000003814697 33.15000152587891 16.57500076293945 33.15000152587891 C 25.72900009155273 33.15000152587891 33.15000152587891 25.72900009155273 33.15000152587891 16.57500076293945 C 33.15000152587891 7.421000003814697 25.72900009155273 0 16.57500076293945 0 Z M 24.32099914550781 23.35300064086914 C 21.76499938964844 23.36000061035156 19.20999908447266 23.35499954223633 16.65399932861328 23.35600090026855 C 14.09899997711182 23.35700035095215 11.54300022125244 23.35899925231934 8.987000465393066 23.35600090026855 C 7.505000114440918 23.35400009155273 6.896999835968018 22.77199935913086 6.892000198364258 21.31100082397461 C 6.88100004196167 18.15900039672852 6.88100004196167 15.00699996948242 6.888999938964844 11.85499954223633 C 6.892000198364258 10.42899990081787 7.482999801635742 9.809000015258789 8.902999877929688 9.805000305175781 C 14.04300022125244 9.788999557495117 19.18199920654297 9.789999961853027 24.32200050354004 9.798000335693359 C 25.64900016784668 9.800999641418457 26.26000022888184 10.42599964141846 26.26199913024902 11.72700023651123 C 26.26700019836426 14.96399974822998 26.26899909973145 18.20100021362305 26.26399993896484 21.4379997253418 C 26.26099967956543 22.73500061035156 25.63699913024902 23.34900093078613 24.32099914550781 23.35300064086914 Z">
                </path>
              </svg>
            </div>
            <span><a href="mailto:contact.dirigo@kst.co.id">contact.dirigo@kst.co.id</a></span>
          </span>
          <br><br><br><br>
          <span class="modal_button" @click="isModalActive = false">Oke!</span>
        </div>
      </div>
    </b-modal>
    <div id="section1">
      <div id="section1_left">
        <div id="circle_laptop1"/>
        <div id="circle_laptop2"/>
        <!-- <img id="Laptop" src="../../../assets/Laptop.png" srcset="../../../assets/Laptop.png 1x, Laptop@2x.png 2x"> -->
        <img id="Laptop" src="../../../assets/Laptop.png"/>
      </div>
      <div id="section1_right">
        <div id="siapa_bilang">CAPEK NGURUS TOKO?</div>
        <div id="semua_mudah">Jadikan Mudah Dengan Dirigo!</div>
        <div id="section3_left_p2">Sistem inventaris digital yang menyediakan laporan stok dan penjualan secara real time.</div>
        <div @click="goToTargetView('signup')" class="section_button">Coba Gratis</div>
        <!-- <div @click="goToTargetView('signup')" id="Jadi_TemanMelangkah_kami_layout">
          <div id="Jadi_TemanMelangkah_kami">
            <span>Jadi #TemanMelangkah kami</span>
          </div>
          <svg class="Path_102" viewBox="0 0 33.323 33.323">
            <path id="Path_102" d="M 16.66130256652832 0 C 7.480584621429443 0 0 7.480584621429443 0 16.66130256652832 C 0 25.84201812744141 7.480584621429443 33.32260513305664 16.66130256652832 33.32260513305664 C 25.84201812744141 33.32260513305664 33.32260513305664 25.84201812744141 33.32260513305664 16.66130256652832 C 33.32260513305664 7.480584621429443 25.84201622009277 0 16.66130256652832 0 Z M 22.61176490783691 17.25634765625 L 14.45112705230713 25.50199127197266 C 14.28111457824707 25.67200469970703 14.02609443664551 25.75701141357422 13.77107620239258 25.75701141357422 C 13.51605606079102 25.75701141357422 13.26103591918945 25.6720027923584 13.09102249145508 25.50199127197266 C 12.75099658966064 25.16196441650391 12.75099658966064 24.56691741943359 13.09102249145508 24.22689056396484 L 20.65661239624023 16.66130256652832 L 13.17602729797363 9.180717468261719 C 12.8360013961792 8.840690612792969 12.8360013961792 8.245643615722656 13.17602729797363 7.905617237091064 C 13.51605415344238 7.565590858459473 14.11110019683838 7.565590858459473 14.45112705230713 7.905617237091064 L 22.61176490783691 16.06625556945801 C 22.78178024291992 16.23626899719238 22.86678504943848 16.49128913879395 22.86678504943848 16.74630737304688 C 22.86678504943848 17.00132751464844 22.78177833557129 17.08633422851563 22.61176490783691 17.25634765625 Z">
            </path>
          </svg>
        </div> -->
      </div>
    </div>
    <!-- <video id="section_video" controls controlsList="nodownload" autoplay loop muted>
      <source src="../../../assets/videos/home_demo.webm" type="video/mp4">
      Your browser does not support the video tag.
    </video> -->
    <iframe id="section_video_yt" src="https://www.youtube.com/embed/c7701b6cvrA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <div id="section2">
      <div class="section2_child">
        <img class="section2_icon_laptop" src="../../../assets/home_benefits_laptop.png"/>
        <span class="section2_title">SEMUA BISA PAKAI</span>
        <span class="section2_content">Kamu tidak perlu lagi menghabiskan waktu lama untuk memahami sistem kami. Dirigo didesain khusus agar bisa dipakai semua orang dari semua kalangan.</span>
      </div>
      <div class="section2_child">
        <img class="section2_icon_wfh" src="../../../assets/home_benefits_wfh.png"/>
        <span class="section2_title">KERJA DARI RUMAH? BISA!</span>
        <span class="section2_content">Pastikan kamu bekerja cerdas, bukan hanya bekerja keras. Dengan dirigo, kamu tidak perlu lagi mengawasi bisnis UMKM-mu, biarkan kami yang berikan laporannya untukmu.</span>
      </div>
      <div class="section2_child">
        <img class="section2_icon_idea" src="../../../assets/home_benefits_idea.png"/>
        <span class="section2_title">BUKAN SAATNYA FOKUS PADA YANG RUTIN</span>
        <span class="section2_content">Di saat kamu fokus pada administrasi, jutaan pengusaha lainnya sedang memikirkan cara mengembangkan usaha mereka. Kembangkan usahamu, biar kami yang tangani pekerjaan rutin UMKM-mu.</span>
      </div>
    </div>

    <div id="section3">
      <div id="section3_left">
        <div id="section3_left_title">INI YANG AKAN KAMU DAPATKAN</div>
        <div id="section3_left_p2">Dengan Dirigo, kamu bisa dapatkan berbagai laporan stok, penjualan, dan fitur lainnya secara REAL TIME.</div>
        <div id="section3_left_p1">Selagi Kami Fokus <span id="section3_left_p1_color">Menyediakan</span> yang Rutin,</div>
        <div id="section3_left_p1">Kamu Bisa Fokus <span id="section3_left_p1_color">Mengatur</span> Strategi Bisnis</div>
        <br><br>
        <div @click="goToTargetView('features')" class="section_button">Halaman Fitur</div>
        <!-- <div @click="goToTargetView('features')" id="section3_left_button">
          <div id="section3_left_button_label">
            <span>Cari tahu lebih lanjut</span>
          </div>
          <svg class="Path_102_p" viewBox="0 0 33.323 33.323">
            <path id="Path_102_p" d="M 16.66130256652832 0 C 7.480584621429443 0 0 7.480584621429443 0 16.66130256652832 C 0 25.84201812744141 7.480584621429443 33.32260513305664 16.66130256652832 33.32260513305664 C 25.84201812744141 33.32260513305664 33.32260513305664 25.84201812744141 33.32260513305664 16.66130256652832 C 33.32260513305664 7.480584621429443 25.84201622009277 0 16.66130256652832 0 Z M 22.61176490783691 17.25634765625 L 14.45112705230713 25.50199127197266 C 14.28111457824707 25.67200469970703 14.02609443664551 25.75701141357422 13.77107620239258 25.75701141357422 C 13.51605606079102 25.75701141357422 13.26103591918945 25.6720027923584 13.09102249145508 25.50199127197266 C 12.75099658966064 25.16196441650391 12.75099658966064 24.56691741943359 13.09102249145508 24.22689056396484 L 20.65661239624023 16.66130256652832 L 13.17602729797363 9.180717468261719 C 12.8360013961792 8.840690612792969 12.8360013961792 8.245643615722656 13.17602729797363 7.905617237091064 C 13.51605415344238 7.565590858459473 14.11110019683838 7.565590858459473 14.45112705230713 7.905617237091064 L 22.61176490783691 16.06625556945801 C 22.78178024291992 16.23626899719238 22.86678504943848 16.49128913879395 22.86678504943848 16.74630737304688 C 22.86678504943848 17.00132751464844 22.78177833557129 17.08633422851563 22.61176490783691 17.25634765625 Z">
            </path>
          </svg>
        </div> -->
      </div>
      <div id="section3_right">
        <!-- slider -->
        <!-- <img src="../../../assets/featurebg.png"/> -->
        <!-- <svg class="Union_1_bt" viewBox="0 0 927.36 733.391">
          <linearGradient id="Union_1_bt" spreadMethod="pad" x1="0.5" x2="0.5" y1="0" y2="1">
            <stop offset="0" stop-color="#f47d20" stop-opacity="1"></stop>
            <stop offset="1" stop-color="#f99f1b" stop-opacity="1"></stop>
          </linearGradient>
          <path id="Union_1_bt" d="M 542.5554809570313 584.6094360351563 C 485.1634216308594 632.7069702148438 411.2232971191406 661.6526489257813 330.5157470703125 661.6526489257813 C 147.9769287109375 661.6526489257813 0 513.536376953125 0 330.8267517089844 C 0 148.1162261962891 147.9769287109375 0 330.5157470703125 0 C 513.0546264648438 0 661.031494140625 148.1162261962891 661.031494140625 330.8267517089844 C 661.031494140625 338.8671569824219 660.7443237304688 346.8487854003906 660.180908203125 354.7454833984375 C 682.4363403320313 345.8837890625 706.693115234375 341.0157775878906 732.0880126953125 341.0157775878906 C 839.932861328125 341.0157775878906 927.3596801757813 428.8523254394531 927.3596801757813 537.2034301757813 C 927.3596801757813 645.5545654296875 839.932861328125 733.39111328125 732.0880126953125 733.39111328125 C 640.5137939453125 733.39111328125 563.6612548828125 670.054931640625 542.5554809570313 584.6094360351563 Z">
          </path>
        </svg> -->
        <div id="Component_55__1" class="Component_55___1">
          <img id="Group_631" ref="Group_631" src="../../../assets/feature5.png" />
          <img id="Group_630" ref="Group_630" src="../../../assets/feature4.png" />
          <img id="Group_629" ref="Group_629" src="../../../assets/feature3.png" />
          <img id="Group_628" ref="Group_628" src="../../../assets/feature2.png" />
          <img id="Group_627" ref="Group_627" src="../../../assets/feature1.png" />
          <div id="Group_74">
            <svg class="Ellipse_21">
              <ellipse id="Ellipse_21" ref="Ellipse_21" rx="6.5" ry="6.5" cx="6.5" cy="6.5">
              </ellipse>
            </svg>
            <svg class="Ellipse_23">
              <ellipse id="Ellipse_23" ref="Ellipse_23" rx="6.5" ry="6.5" cx="6.5" cy="6.5">
              </ellipse>
            </svg>
            <svg class="Ellipse_24">
              <ellipse id="Ellipse_24" ref="Ellipse_24" rx="6.5" ry="6.5" cx="6.5" cy="6.5">
              </ellipse>
            </svg>
            <svg class="Ellipse_65">
              <ellipse id="Ellipse_65" ref="Ellipse_65" rx="6.5" ry="6.5" cx="6.5" cy="6.5">
              </ellipse>
            </svg>
            <svg class="Ellipse_66">
              <ellipse id="Ellipse_66" ref="Ellipse_66" rx="6.5" ry="6.5" cx="6.5" cy="6.5">
              </ellipse>
            </svg>
          </div>
          <a href="javascript:;" @click="onClickPrevBanner">
            <svg class="Path_773" viewBox="0 0 44 43.598">
              <path id="Path_773" d="M 22 0 C 34.1224479675293 0 44 9.787338256835938 44 21.799072265625 C 44 33.8108024597168 34.1224479675293 43.59814453125 22 43.59814453125 C 9.877555847167969 43.59814453125 0 33.8108024597168 0 21.799072265625 C 0 9.787338256835938 9.877555847167969 0 22 0 Z M 14.14285850524902 22.57761001586914 L 24.91836929321289 33.36592483520508 C 25.14285850524902 33.58836364746094 25.47959518432617 33.6995849609375 25.81632614135742 33.6995849609375 C 26.15306091308594 33.6995849609375 26.48979568481445 33.58836364746094 26.71428680419922 33.36592483520508 C 27.16326713562012 32.92104721069336 27.16326713562012 32.14250946044922 26.71428680419922 31.69762802124023 L 16.7244930267334 21.799072265625 L 26.60204315185547 12.01173400878906 C 27.05102157592773 11.56685447692871 27.05102157592773 10.78831577301025 26.60204315185547 10.3434362411499 C 26.15306091308594 9.898557662963867 25.36734962463379 9.898557662963867 24.91836929321289 10.3434362411499 L 14.14285850524902 21.02053451538086 C 13.91836738586426 21.24297523498535 13.80612564086914 21.57663154602051 13.80612564086914 21.9102897644043 C 13.80612564086914 22.24394989013672 13.91837120056152 22.35517120361328 14.14285850524902 22.57761001586914 Z">
              </path>
            </svg>
          </a>
          <a href="javascript:;" @click="onClickNextBanner">
            <svg class="Path_774" viewBox="0 0 43.598 43.598">
              <path id="Path_774" d="M 21.799072265625 0 C 9.787338256835938 0 0 9.787338256835938 0 21.799072265625 C 0 33.8108024597168 9.787338256835938 43.59814453125 21.799072265625 43.59814453125 C 33.8108024597168 43.59814453125 43.59814453125 33.8108024597168 43.59814453125 21.799072265625 C 43.59814453125 9.787338256835938 33.8108024597168 0 21.799072265625 0 Z M 29.58445358276367 22.57761001586914 L 18.90735626220703 33.36592483520508 C 18.68491744995117 33.58836364746094 18.35125732421875 33.6995849609375 18.01760101318359 33.6995849609375 C 17.68394088745117 33.6995849609375 17.35028266906738 33.58836364746094 17.12784194946289 33.36592483520508 C 16.68296241760254 32.92104721069336 16.68296241760254 32.14250946044922 17.12784194946289 31.69762802124023 L 27.02639770507813 21.799072265625 L 17.23905944824219 12.01173400878906 C 16.79418182373047 11.56685447692871 16.79418182373047 10.78831577301025 17.23905944824219 10.3434362411499 C 17.68394088745117 9.898557662963867 18.46247673034668 9.898557662963867 18.90735626220703 10.3434362411499 L 29.58445358276367 21.02053451538086 C 29.80689430236816 21.24297523498535 29.91811180114746 21.57663154602051 29.91811180114746 21.9102897644043 C 29.91811180114746 22.24394989013672 29.8068904876709 22.35517120361328 29.58445358276367 22.57761001586914 Z">
              </path>
            </svg>
          </a>
        </div>
        <!-- end slider -->
      </div>
    </div>
    
    <div id="section4">
      <span id="section4_title">TESTIMONI</span>
        <div id="section4_title2">Ini cerita Teman Melangkah kami.</div>
      <div id="section4_greenbg"></div>
      <div id="section4_content">
        <a href="javascript:;" @click="onClickPrevTestimony">
          <svg class="section4_left_button" viewBox="0 0 44 43.598">
            <path id="section4_left_button" d="M 22 0 C 34.1224479675293 0 44 9.787338256835938 44 21.799072265625 C 44 33.8108024597168 34.1224479675293 43.59814453125 22 43.59814453125 C 9.877555847167969 43.59814453125 0 33.8108024597168 0 21.799072265625 C 0 9.787338256835938 9.877555847167969 0 22 0 Z M 14.14285850524902 22.57761001586914 L 24.91836929321289 33.36592483520508 C 25.14285850524902 33.58836364746094 25.47959518432617 33.6995849609375 25.81632614135742 33.6995849609375 C 26.15306091308594 33.6995849609375 26.48979568481445 33.58836364746094 26.71428680419922 33.36592483520508 C 27.16326713562012 32.92104721069336 27.16326713562012 32.14250946044922 26.71428680419922 31.69762802124023 L 16.7244930267334 21.799072265625 L 26.60204315185547 12.01173400878906 C 27.05102157592773 11.56685447692871 27.05102157592773 10.78831577301025 26.60204315185547 10.3434362411499 C 26.15306091308594 9.898557662963867 25.36734962463379 9.898557662963867 24.91836929321289 10.3434362411499 L 14.14285850524902 21.02053451538086 C 13.91836738586426 21.24297523498535 13.80612564086914 21.57663154602051 13.80612564086914 21.9102897644043 C 13.80612564086914 22.24394989013672 13.91837120056152 22.35517120361328 14.14285850524902 22.57761001586914 Z">
            </path>
          </svg>
        </a>
        <a href="javascript:;" @click="onClickNextTestimony">
          <svg class="section4_right_button" viewBox="0 0 43.598 43.598">
            <path id="section4_right_button" d="M 21.799072265625 0 C 9.787338256835938 0 0 9.787338256835938 0 21.799072265625 C 0 33.8108024597168 9.787338256835938 43.59814453125 21.799072265625 43.59814453125 C 33.8108024597168 43.59814453125 43.59814453125 33.8108024597168 43.59814453125 21.799072265625 C 43.59814453125 9.787338256835938 33.8108024597168 0 21.799072265625 0 Z M 29.58445358276367 22.57761001586914 L 18.90735626220703 33.36592483520508 C 18.68491744995117 33.58836364746094 18.35125732421875 33.6995849609375 18.01760101318359 33.6995849609375 C 17.68394088745117 33.6995849609375 17.35028266906738 33.58836364746094 17.12784194946289 33.36592483520508 C 16.68296241760254 32.92104721069336 16.68296241760254 32.14250946044922 17.12784194946289 31.69762802124023 L 27.02639770507813 21.799072265625 L 17.23905944824219 12.01173400878906 C 16.79418182373047 11.56685447692871 16.79418182373047 10.78831577301025 17.23905944824219 10.3434362411499 C 17.68394088745117 9.898557662963867 18.46247673034668 9.898557662963867 18.90735626220703 10.3434362411499 L 29.58445358276367 21.02053451538086 C 29.80689430236816 21.24297523498535 29.91811180114746 21.57663154602051 29.91811180114746 21.9102897644043 C 29.91811180114746 22.24394989013672 29.8068904876709 22.35517120361328 29.58445358276367 22.57761001586914 Z">
            </path>
          </svg>
        </a>
        <div id="section4_content_header">
          <!-- <img id="section4_content_header_pic" v-if="inctestimony==0" src="../../../assets/Mask_Group_4.png" srcset="../../../assets/Mask_Group_4.png 1x, Mask_Group_4@2x.png 2x">
          <img id="section4_content_header_pic" v-if="inctestimony==1" src="../../../assets/Mask_Group_5.png" srcset="../../../assets/Mask_Group_5.png 1x, Mask_Group_5@2x.png 2x"> -->
          <img id="section4_content_header_pic" v-if="inctestimony==0" src="../../../assets/home_tstelagawarna.png">
          <img id="section4_content_header_pic" v-if="inctestimony==1" src="../../../assets/Mask_Group_4.png">
          <img id="section4_content_header_pic" v-if="inctestimony==2" src="../../../assets/home_tshaypeng.png">
          <div id="section4_content_header_right">
            <span id="section4_content_header_name">{{ testimony[inctestimony].nama }}</span>
            <span id="section4_content_header_store">{{ testimony[inctestimony].toko }}</span>
          </div>
        </div>
        <div id="section4_content_comment">{{ testimony[inctestimony].komentar }}</div>
      </div>
    </div>

    <div id="section5">
      <div id="section5_left">
        <div id="section5_left_circlebg"/>
          <!-- <img id="section5_left_personpic" src="../../../assets/person_-_homepage.png" srcset="../../../assets/person_-_homepage.png 1x, person_-_homepage@2x.png 2x"> -->
          <img id="section5_left_personpic" src="../../../assets/person_-_homepage.png">
      </div>
      <div id="section5_right">
        <div id="section5_right_title">KAMU JUGA BISA KOK</div>
        <div id="section5_right_p2">Punya profit setinggi CEO<br>Tanpa perlu kerja lembur seperti karyawan toko</div>
        <div id="section5_right_p1">Pilih <p id="section5_right_p1_color">#TemanMelangkah</p> yang tepat!</div>
        <div @click="goToTargetView('signup')" class="section_button">Coba Gratis</div>
      </div>
    </div>
    
    <div id="section6">
      <div id="section6_left">
        <div class="section6_left_title">Starter Pack untuk Pemilik Toko Baru</div>
        <div class="section6_left_p1">Dapatkan template Microsoft Excel untuk pencatatan stok toko kamu secara gratis di sini.</div>
				<input class="section6_left_input" type="email" placeholder="E-mail" v-model="dataExcelDownload.email"/>
        <div @click="onClickDownload()" class="section_button">Dapatkan Sekarang</div>
      </div>
      <div id="section6_right">
        <img src="../../../assets/home_img_person2.png">
      </div>
    </div>
    
    <div id="section7">
      <div id="section7_left">
        <img src="../../../assets/home_img_poster.png">
      </div>
      <div id="section7_right">
        <div class="section7_right_title">Apresiasi Kami untuk Kamu</div>
        <div class="section7_right_p1">Untuk kamu, pemilik-pemilik toko yang kesusahan mengelola sosial media dan melakukan promosi karena kemampuan desain yang terbatas, kami bisa desainkan kamu 1 konten promosi/sosial media secara custom!</div>
        <div @click="onClickOpenModalLeadMagnet()" class="section_button">Dapatkan Sekarang</div>
      </div>
    </div>
  </div>
  </Layout>
</template>
<script>
async function getHomeStyle() {
	await import("./_home.css");
}
async function getFeaturesStyle() {
  await import("../Features/_features.css");
}
async function getContactUsStyle() {
  await import("../ContactUs/_contactus.css");
}

switch (window.location.pathname) {
  case '/home': getHomeStyle(); break;
  case '/features': getFeaturesStyle(); break;
  case '/contactus': getContactUsStyle(); break;
}

import Layout from "../Layout/Layout.vue";
import AxiosMixin from "@/mixins/AxiosMixin.js";
import SnackbarMixin from "@/mixins/SnackbarMixin.js";
import LoadingMixin from "@/mixins/LoadingMixin.js";

export default {
  components: {
    Layout
  },
	mixins: [AxiosMixin, SnackbarMixin, LoadingMixin],
  data: () => ({
    index: 0,
    duration: 5000,
    banners: [],
    bullets: [],
    testimony: [{
          nama: "Marianto Tedy",
          toko: "Toko Telaga Warna",
          komentar: "Dirigo membuat pengelolaan toko baik dari segi pembelian, penjualan, daftar stok dan pembukuan menjadi jauh lebih mudah rapih aman dan dapat diakses kapan dan dimana saja.",
          gambar: 1
        },{
          nama: "Jerry",
          toko: "Toko Mutiara Bali",
          komentar: "Dirigo, sesuai arti namanya, telah memberi kemudahan operasional bagi manajemen kami. User Interface Dirigo yang intuitif dan mudah dipelajari sangat membantu dalam pencatatan transaksi sehari-hari. Didukung dengan tim yang solid dan selalu siap melayani, aplikasi web Dirigo tidak pernah gagal dalam menyediakan apapun yang bisnis kami butuhkan. Terima kasih tim Dirigo!",
          gambar: 2
        },{
          nama: "Mili",
          toko: "Toko Hay Peng",
          komentar: "Sebelum menggunakan Dirigo, toko kami melakukan sistem pencatatan manual. Untuk mencari data barang membutuhkan waktu, belum lagi kalau kertasnya hilang. Dengan Dirigo, data toko bisa diakses kapan saja dan dari mana saja dengan waktu yang sangat singkat. Perhitungan stok juga lebih mudah dan akurat. Sistem Dirigo simpel sehingga mudah dimengerti dan digunakan, cocok untuk toko tradisional yang baru mulai berkembang ke arah digital. Thank you Dirigo for making our lives easier.",
          gambar: 3
        }],
    inctestimony: 0,
    timer: null,
    isModalActive: false,
    modalPage: 1,
		dataModal: {},
		dataExcelDownload: {},
		loading: null,
    modalPage3Titleline1: 'Selamat!',
    modalPage3Titleline2: 'Iklan Anda Sedang Diproses!',
    modalPage3Title2: 'Tim Dirigo akan menghubungi anda dalam maksimal 3x24 jam',
    modalPage3Title3: 'Silahkan cek e-mail anda secara berkala.'
  }),
  mounted() {
    this.init();
    this.$gtag.pageview('/home')
  },
  methods: {
    init() {
      this.initBanner();
      this.dataModal.terima_promosi = false;
      this.dataModal.jenis_usaha = "Kuliner";
      // this.initTestimony();
    },
    initBanner() {
      this.banners = [
        this.$refs.Group_631,
        this.$refs.Group_630,
        this.$refs.Group_629,
        this.$refs.Group_628,
        this.$refs.Group_627
      ];
      this.bullets = [
        this.$refs.Ellipse_21,
        this.$refs.Ellipse_23,
        this.$refs.Ellipse_24,
        this.$refs.Ellipse_65,
        this.$refs.Ellipse_66
      ]
      //this.timer = setInterval(this.nextBanner, this.duration);
    },
    highlightByClass(classselector, index) {
      if(typeof classselector == "string" && typeof index == "number") {
          let el = document.getElementsByClassName(classselector);
          el.forEach(function (value, i) {
              if(i == index) {
                  el[i].style.borderStyle = 'solid';
                  el[i].style.transform = 'scale(1.2)';
                  el[i].style.opacity = 1;
              } else {
                  el[i].style.borderStyle = 'none';
                  el[i].style.transform = 'scale(1)';
                  el[i].style.opacity = 0.6;
              }
          });
      }
      this.dataModal.posterId = index + 1;
    },
    goToModalPage(page) {
      this.modalPage = page;
    },
    onClickOpenModalLeadMagnet() {
      this.isModalActive = true;
      this.dataModal.posterId = 1;
      this.goToModalPage(1);
    },
    initTestimony() {
        this.testimony = [{
          nama: "Jerry",
          toko: "Toko Mutiara Bali",
          komentar: "Dirigo, as the name suggest has brought ease of control for our management team and intuitive user interface provides ease of learning to access and use in daily transaction. With Dirigo's strong team and their availability, the web application never fail to assist us in tailor-made whatever we need for our business and customer's needs. Thank you Dirigo team!",
          gambar: 1
        },{
          nama: "Marianto Tedy",
          toko: "Toko Telaga Warna",
          komentar: "Dirigo membuat pengelolaan toko baik dari segi pembelian, penjualan, daftar stok dan pembukuan menjadi jauh lebih mudah rapih aman dan dapat diakses kapan dan dimana saja. ",
          gambar: 2
        }]
    },
    onClickNextTestimony() {
      if(this.inctestimony < 2) {
        this.inctestimony += 1;
      } else {
        this.inctestimony = 0;
      }
    },
    onClickPrevTestimony() {
      if(this.inctestimony > 0) {
        this.inctestimony -= 1;
      } else {
        this.inctestimony = 2;
      }
    },
    onClickPrevBanner() {
      this.nextBanner(-1);
    },
    onClickNextBanner() {
      this.nextBanner(1);
    },
    nextQueue(cmp) {
      let result = [];
      for(let i in cmp) {
        if(parseInt(i) + 1 == cmp.length) {
          result[i] = cmp[0];
        } else {
          result[i] = cmp[parseInt(i) + 1];
        }
      }
      return result;
    },
    prevQueue(cmp) {
      let result = [];
      for(let i in cmp) {
        if(parseInt(i) > 0) {
          result[i] = cmp[parseInt(i) - 1]
        } else {
          result[i] = cmp[cmp.length - 1];
        }
      }
      return result;
    },
    nextBanner(counter) {
      this.banners = this.moveQueue(this.banners, -counter);
      this.bullets = this.moveQueue(this.bullets, counter);
      const banner0 = { top: "15%", left: "60%", width: "30%", height: "50%", zIndex: "12", opacity: "0.5" };
      const banner1 = { top: "8%", left: "43%", width: "40%", height: "65%", zIndex: "10", opacity: "0.75" };
      const banner2 = { top: "0%", left: "25%", width: "50%", height: "80%", zIndex: "14", opacity: "1" };
      const banner3 = { top: "8%", left: "17%", width: "40%", height: "65%", zIndex: "11", opacity: "0.75" };
      const banner4 = { top: "15%", left: "10%", width: "30%", height: "50%", zIndex: "13", opacity: "0.5" };
      this.changeBannerProp(this.banners[0], banner0);
      this.changeBannerProp(this.banners[1], banner1);
      this.changeBannerProp(this.banners[2], banner2);
      this.changeBannerProp(this.banners[3], banner3);
      this.changeBannerProp(this.banners[4], banner4);
      for(let i in this.bullets) {
        if(i == 0) {
          this.bullets[0].style.fill = "rgba(255,255,255,1)";
        } else {
          this.bullets[i].style.fill = "rgba(255,255,255,0.38)";
        }
      }
      // if(this.timer) {
      //   clearInterval(this.timer);
      // }
      //this.timer = setInterval(this.nextBanner, this.duration);
    },
    moveQueue(cmp, counter) {
      if(counter && counter < 0) {
        return this.prevQueue(cmp);
      } else {
        return this.nextQueue(cmp);
      }
    },
    changeBannerProp(banner, params) {
      banner.style.top = params.top;
      banner.style.left = params.left;
      banner.style.width = params.width;
      banner.style.height = params.height;
      banner.style.zIndex = params.zIndex;
      banner.style.opacity = params.opacity;
    },
    onClickSendModal() {
      if(this.dataModal._name && this.dataModal._nama_toko && this.dataModal.email && this.dataModal.telephone && this.dataModal.jenis_usaha && this.dataModal.message) {
        this.loading = this.openLoading();
        this.sendDataModal().then(() => {
          this.closeLoading(this.loading);
          this.onSuccessSendMessage();
        })
      } else {
        alert("Mohon untuk melengkapi data Anda terlebih dahulu.");
      }
		},
		onSuccessSendMessage() {
      this.modalPage3Titleline1 = 'Selamat!';
      this.modalPage3Titleline2 = 'Iklan Anda Sedang Diproses!';
      this.modalPage3Title2 = 'Tim Dirigo akan menghubungi anda dalam maksimal 3x24 jam';
      this.modalPage3Title3 = 'Silahkan cek e-mail anda secara berkala.';
			this.goToModalPage(3);
		},
		sendDataModal() {
			// return new Promise(resolve => {
			// 	const config = Services.postMessage(this.dataModal);
			// 	this.runAxios(config, null, () => resolve());
			// })
		},
    validateEmail(value) {
      value = value || "";
      let result;
      const reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if(!reg.test(value)) {
        result = { error: "Email tidak valid" }
      }
      if(!value) {
        result = { error: "Nama tidak boleh kosong" }
      }
      return result;
    },
    onClickDownload() {
      const validateUserEmail = this.validateEmail(this.dataExcelDownload.email);
      if(!validateUserEmail) {
        this.loading = this.openLoading();
        this.dataExcelDownload._subject = 'Email from downloading excel template'
        this.sendDataDownload().then(() => {
          this.closeLoading(this.loading);
          this.onSuccessDownload();
        })
      } else {
        alert("Mohon untuk mengisi email dengan benar.");
      }
		},
		onSuccessDownload() {
      this.modalPage3Titleline1 = 'Template Excel kamu';
      this.modalPage3Titleline2 = 'berhasil di download!';
      this.modalPage3Title2 = 'Semoga berguna!';
      this.modalPage3Title3 = '';
			this.isModalActive = true;
			this.goToModalPage(3);
			this.goToTargetView('../../../../documents/Inventaris Template.xlsx');
      this.dataExcelDownload.email = '';
		},
		sendDataDownload() {
			// return new Promise(resolve => {
			// 	const config = Services.postMessage(this.dataExcelDownload);
			// 	this.runAxios(config, null, () => resolve());
			// })
		},
    goToTargetView(goto) {
      if(typeof goto == "string") {
        window.location.href = goto;
      }
    },
    goToTargetViewBlank(goto) {
      window.open(goto, '_blank');
    }
  }
}
</script>
<style scoped lang="css" src="./_home.css"/>
